import CircularProgress from '@mui/material/CircularProgress';
import Grid from '@mui/material/Grid';
import { useTheme } from '@mui/material/styles';
import { ComponentType, Suspense, memo } from 'react';
import { Navigate } from 'react-router';

import { useAuth } from '@/auth';
import { NavBarSkeleton } from '@/componentsv2/NavBar/Root';

interface ProtectedRouteProps {
  component: ComponentType;
  disabled?: boolean;
  redirectTo?: string;
}

export function Loading() {
  const theme = useTheme();

  return (
    <Grid
      container
      direction="column"
      justifyContent="flex-start"
      alignItems="stretch"
      sx={{
        minHeight: '100vh',
        background: 'green',
      }}
    >
      <Grid item>
        <NavBarSkeleton />
      </Grid>
      <Grid
        container
        flexGrow={1}
        justifyContent="center"
        alignItems="center"
        sx={{
          background: theme.palette.grey[100],
          padding: theme.spacing(2),
        }}
      >
        <Grid
          item
          sx={{
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <CircularProgress
            size={100}
            thickness={3}
            sx={{
              color: 'orange',
            }}
          />
        </Grid>
      </Grid>
    </Grid>
  );
}

const ProtectedRoute = ({ component, disabled, redirectTo }: ProtectedRouteProps) => {
  const { viewer } = useAuth();
  const isLoading = false;
  const isAuthenticated = !!viewer.id;
  //const { data: viewer } = useAppSelector(userSelector);

  if (disabled && redirectTo) {
    return <Navigate to={redirectTo} replace />;
  }

  if (isLoading || !isAuthenticated || !viewer?.id) {
    return <Loading />;
  }

  // const Component = withAuthenticationRequired(
  //   isLoading || !isAuthenticated || !viewer?.id ? Loading : component,
  //   {
  //     onRedirecting: () => <Loading />,
  //   }
  // );

  const Component = component;
  return (
    <Suspense fallback={<Loading />}>
      <Component />
    </Suspense>
  );
};

export default memo(ProtectedRoute);
